import * as moment from "moment";

export class Util{
    
    constructor(){
        
    }
    
    static isMobile():boolean{
        let ismobile = navigator.userAgent.match(/(iPad)|(iPhone)|(iPod)|(android)|(webOS)/i);
        if(ismobile){
            return true;
               
        }else{
            return false;
        }
    }
    
    static truncateString(value:string,lengthToCut:number):string{
         if(value!= null && value.length>lengthToCut){
            return value.substring(0,lengthToCut)+"...";
        }else{
            return value;
        }
    }

    static formatDistance(km: number): string {
        if (km) {
            if (km < 1) {
                return (km * 1000).toFixed(2) + " m";
            } else {
                return km.toFixed(2) + " Km";
            }
        }
        return "0 Km"

    }
    
    
    static formatByte(byte:number):string{
        if(byte>0){
            let result:any=0;
            let megaByte=1000000;
            let kilobyte=1000;
            
            if(byte>999 && byte<megaByte){
                result=(byte/kilobyte);
                result=result.toFixed(2)+" Kb";

            }else if(byte>=megaByte){
                result=(byte/megaByte);
                result=result.toFixed(2)+" Mb";
                
            }else if(byte<=999){
              result=byte+" Bytes"  
            }

            return result;
            
        }else return "-";
    }

    static getParameterByName(name:string) {
        name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
        let regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
            results = regex.exec(window.location.href);
        return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
    }

    static isSameOrAfter(initDate: string, endDate: string, format: string): boolean {
        return moment(initDate, format).isSameOrAfter(moment(endDate, format));
    }

    static isSameOrBefore(initDate: string, endDate: string, format: string): boolean {
        return moment(initDate, format).isSameOrBefore(moment(endDate, format));
    }

    static isAfter(initDate: string, endDate: string, format: string): boolean {
        return moment(initDate, format).isAfter(moment(endDate, format));
    }

    static isBefore(initDate: string, endDate: string, format: string): boolean {
        return moment(initDate, format).isBefore(moment(endDate, format));
    }

    /**
     * resta dos fechas y retonara las horas de diferencia
     * @param initDate 
     * @param endDate 
     * @param format 
     */
    static hoursDifference(initDate: string, endDate: string, format: string): number {
        let hoursDifference: number = moment(endDate, format).diff(moment(initDate, format), 'hours', true);
        return hoursDifference;
    }

    static randomString(length?: number): string {
        let result = '';
        let chars = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
        let numLength: number = (length != null && length > 0) ? length : 32;
        for (let i = numLength; i > 0; --i) result += chars[Math.floor(Math.random() * chars.length)];
        return result;
    }

    static fileToBase64(file: File): Promise<string> {
        return new Promise((resolve: any, reject: any) => {
            let reader = new FileReader();
            reader.readAsDataURL(file);

            reader.onload = function () {
                resolve(reader.result);
            };
            reader.onerror = function (error) {
                reject(error);
            };
        });
    }

    /**
     * Función que evalua si un number es par
     * Devuelve true si el numero es par y
     * false si es impar
     * @param number
     */
    static numberIsPair(number: number): boolean {
        if (number != null) {
            if (number % 2 == 0) {
                return true;
            } else {
                return false;
            }
        } else {
            throw new Error("La variable number es obligatoria");
        }
    }

    static setLocalStorage(key: string, value: any) {
        window.localStorage[key] = JSON.stringify(value);
    }

    static getLocalStorage<Type>(key: string): Type {
        let value: any = window.localStorage[key];
        if (value) {
            return JSON.parse(value);
        } else {
            return null;
        }
    }

    static setSessionStorage(key: string, value: any) {
        window.sessionStorage[key] = JSON.stringify(value);
    }

    static getSessionStorage<Type>(key: string): Type {
        let value: any = window.sessionStorage[key];
        if (value) {
            return JSON.parse(value);
        } else {
            return null;
        }
    }





    /**
     * Método que solo permite que se ingresen
     * números en un input
     */
    validateOnlyNumbers(e: KeyboardEvent) {
        const KEY_CODES_ALLOWED: any = {
            DELETE_KEY: 8,
            SUPR_KEY: 46,
            TAB_KEY: 9,
            LEFT_KEY: 37,
            RIGHT_KEY: 39,
            MINUS_KEY: 109,
            GUION_KEY: 189
        };
        let keyCode: number = e.keyCode;
        // Si las teclas presionas son diferentes a los numeros tanto en el teclado numerico como en el alfanumerico
        if (!(keyCode >= 48 && keyCode <= 57) && !(keyCode >= 96 && keyCode <= 105) &&
            keyCode != KEY_CODES_ALLOWED.TAB_KEY && keyCode != KEY_CODES_ALLOWED.DELETE_KEY && keyCode != KEY_CODES_ALLOWED.SUPR_KEY &&
            keyCode != KEY_CODES_ALLOWED.RIGHT_KEY && keyCode != KEY_CODES_ALLOWED.LEFT_KEY &&
            keyCode != KEY_CODES_ALLOWED.MINUS_KEY && keyCode != KEY_CODES_ALLOWED.GUION_KEY) {
            e.preventDefault();
        }
    }
}